import { jsx as _jsx } from "react/jsx-runtime";
import { TreeList } from "@air/component-tree";
export const BoardSelectList = (param)=>{
    let { initialIndex, items, renderListItem, scrollElement } = param;
    return /*#__PURE__*/ _jsx("section", {
        className: "flex flex-col",
        children: /*#__PURE__*/ _jsx(TreeList, {
            initialIndex: initialIndex,
            items: items,
            getEstimateSize: ()=>32,
            renderListItem: renderListItem,
            scrollElement: scrollElement
        })
    });
};
